import Popup from "../components/popup";
import FileInput from '../utils/class/fileInput';

export default class SingleVacancy {
    constructor(query) {
        const el = document.querySelector(query);

        if (!el) return;

        this.el = el;
        this.popup = document.querySelector('.form-popup[data-popup="popup"]');

        this.init();
        this.initFileInputs();
        this.initFormSuccess();
        this.initSuccessClose();
    }

    init() {
        if (!this.popup) return;

        new Popup({
            popup: '.form-popup[data-popup=popup]',
            toggle: '.form-popup__toggle[data-popup=popup]',
            close: '.form-popup__close[data-popup=popup]',
            window: '.form-popup__window[data-popup=popup]',
        });
    }

    initFileInputs() {
        new FileInput({
            root: this.el,
        });
    }

    initFormSuccess() {
        if (!this.popup) return;

        this.formBlock = this.popup.querySelector('.form-popup__form');
        this.title = this.popup.querySelector('.form-popup__title');
        this.text = this.popup.querySelector('.form-popup__text');
        this.successBlock = this.popup.querySelector('.form-popup__success-wrapper');

        if (!this.formBlock || !this.successBlock) return;

        document.addEventListener('wpcf7mailsent', (event) => {
            const formInsidePopup = this.popup.querySelector('form');

            if (!formInsidePopup) return;
            if (event.target !== formInsidePopup) return;

            this.showSuccess();
        });
    }

    initSuccessClose() {
        if (!this.popup) return;

        this.successCloseBtn = this.popup.querySelector('.form-popup__success-close');

        if (!this.successCloseBtn) return;

        this.successCloseBtn.addEventListener('click', () => {
            this.hideSuccess();
            this.closePopup();
        });
    }

    showSuccess() {
        this.formBlock.style.display = 'none';
        this.title.style.display = 'none';
        this.text.style.display = 'none';
        this.successBlock.style.display = 'flex';
    }

    hideSuccess() {
        if (this.formBlock) {
            this.formBlock.style.display = '';
        }

        if (this.successBlock) {
            this.successBlock.style.display = '';
        }
    }

    closePopup() {
        if (!this.popup) return;

        this.popup.classList.remove('active');
        document.documentElement.classList.remove('popup-open');
        document.body.classList.remove('popup-open');
    }
}